/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Running_TargetInputs */

const en_portal_goal_running_target = /** @type {(inputs: Portal_Goal_Running_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A half marathon under 1:50`)
};

const pl_portal_goal_running_target = /** @type {(inputs: Portal_Goal_Running_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Półmaraton poniżej 1:50`)
};

/**
* | output |
* | --- |
* | "A half marathon under 1:50" |
*
* @param {Portal_Goal_Running_TargetInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_running_target = /** @type {((inputs?: Portal_Goal_Running_TargetInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Running_TargetInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_running_target(inputs)
	return en_portal_goal_running_target(inputs)
});